import React, {useState} from 'react';
import {Modal} from '../modal/Modal';

export function ConfirmModal({title, trigger, triggerWrap = true, handleOk}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const ok = () => {
    setLoading(true);
    Promise.resolve(handleOk()).then((res) => {
      setLoading(false);
      if (res) {
        setOpen(false);
      }
    }).catch(() => {
      setLoading(false);
    })
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap}>
    <React.Fragment>
      <div className="modal__title">Подтвердите действие</div>
      <p className="modal__subtitle">{title}</p>
      <button type="button" className="modal__btn btn" onClick={ok}>Подтвердить</button>
      <button type="button" className="modal__btn modal__btn--cancel btn" disabled={loading} onClick={() => handleOpen(false)}>Отменить</button>
    </React.Fragment>
  </Modal>
};
